import React from "react";
import styles from "./styles.module.scss";

const InputField = ({
  label,
  name,
  type = "text",
  onChange,
  required = false,
  value,
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className={styles.input}>
      {type === "textarea" ? (
        <textarea
          placeholder={label}
          name={name}
          value={value}
          onChange={handleChange}
          rows={4}
        />
      ) : (
        <input
          type={"text"}
          placeholder={label}
          name={name}
          value={value}
          onChange={handleChange}
          required={required}
        />
      )}
    </div>
  );
};

export default InputField;
